export function PageHeader({ eyebrow, title, description, actions, artwork }) {
  return <header className="page-header" data-testid="page-header">
    <div className="page-heading"><span className="eyebrow" data-testid="page-eyebrow">{eyebrow}</span><h1 data-testid="page-title">{title}</h1><p data-testid="page-description">{description}</p>{actions && <div className="header-actions">{actions}</div>}</div>
    {artwork && <div className="header-art"><img src={artwork} alt="" /></div>}
  </header>;
}
